import "./styles.scss";
import ReportProblemRoundedIcon from "@mui/icons-material/ReportProblemRounded";
import SettingsSuggestRoundedIcon from "@mui/icons-material/SettingsSuggestRounded";
import SupportAgentRoundedIcon from "@mui/icons-material/SupportAgentRounded";
import GavelRoundedIcon from "@mui/icons-material/GavelRounded";

export default function OurServices() {
	const services = [
		{
			icon: <ReportProblemRoundedIcon />,
			title: "ترتيب بياناتك",
			subtitle: "نجمع التفاصيل المهمة ونرتبها بطريقة واضحة تسهّل متابعة الطلب",
		},
		{
			icon: <SettingsSuggestRoundedIcon />,
			title: "صياغة واضحة",
			subtitle: "نساعدك في تحويل التفاصيل إلى طلب منظم وسهل المراجعة",
		},
		{
			icon: <SupportAgentRoundedIcon />,
			title: "تواصل مخصص",
			subtitle: "نتواصل معك لمراجعة البيانات وتوضيح النواقص التنظيمية فقط",
		},
		{
			icon: <GavelRoundedIcon />,
			title: "حدود واضحة",
			subtitle: "لا نقدم تمثيلاً أو استشارات قانونية ولا نرسل الشكوى نيابة عنك",
		},
	];

	return (
		<div className="our-services-container">
			{services.map((service, i) => (
				<div key={i} className="service-card">
					<div className="service-card-icon-wrapper">{service.icon}</div>

					<div className="service-card-content">
						<h3 className="service-card-title">{service.title}</h3>
						<p className="service-card-subtitle">{service.subtitle}</p>
					</div>
				</div>
			))}
		</div>
	);
}
